module.exports = __webpack_public_path__ + "media/wyposazenie/ilosc-drzwi@3x-76314978.svg";